// extracted by mini-css-extract-plugin
module.exports = {"list":"FJAdjustView_list__3VPA_"};